var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#B41514"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.714 7.287a1.714 1.714 0 1 1-3.428 0a1.714 1.714 0 0 1 3.428 0m0 11.142a1.714 1.714 0 1 1-3.428 0a1.714 1.714 0 0 1 3.428 0m-8.143-4.715h12.857v2.143H5.571z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.143 6c.162 3.577 3.17 6.429 6.857 6.429c3.686 0 6.694-2.852 6.857-6.429H16.7c-.22 2.357-2.24 4.203-4.7 4.203S7.52 8.357 7.302 6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJst);
export default __webpack_public_path__ + "static/media/jst.72a81d4055800f56857b0a1c17a7b4c3.svg";
export { ForwardRef as ReactComponent };